import { SiteLocales } from "../../../../../common/enums";
import { LanguageOption } from "./types";

export const BASE_SUPPORTED_LANGUAGES: Array<LanguageOption> = [
  { code: SiteLocales.EN_GB, title: "English (UK)" },
  { code: SiteLocales.EN_US, title: "English (US)" },
  { code: SiteLocales.FR_FR, title: "Français" },
  { code: SiteLocales.DE_DE, title: "Deutsch" },
  { code: SiteLocales.JA_JP, title: "日本語 (JP)" },
  { code: SiteLocales.KO_KR, title: "한국인 (KR)" },
  { code: SiteLocales.PT_BR, title: "Português (BR)" },
  { code: SiteLocales.ES_MX, title: "Español (MX)" }
];
